import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Icon, Segment } from 'semantic-ui-react';

import { CustomTable, SlideoutPanel } from '../../../components';
import { EvidenceLibrary } from './evidenceLibrary';
import { isEmpty } from '../../../utils/lodash';

import { EvidenceCreate, EvidenceEdit, EvidenceDelete } from './evidence';

import {
  deleteObjectiveEvidence,
  getEvidenceTypes,
} from '../../../store/actions';

import { getPageDisable, getActivityType } from '../../../utils';
import { ActivityParentGoalAndObjective } from './selectedGAndO';

import {
  getEvidenceDisplayTitle,
  getEvidenceTypeLine,
} from '../../../utils/evidenceTypes';

import './activity.scss';

class ActivityParentEvidence extends PureComponent {
  state = {
    libraryOpen: false,
  };

  toggleLibrary = () => {
    this.setState((prevState) => ({ libraryOpen: !prevState.libraryOpen }));
  };

  columns() {
    const { t, currentState, auth, activity } = this.props;
    const { currentActivity } = activity;
    let disabled = getPageDisable(currentActivity, auth.user, currentState);

    return [
      {
        title: t('common.title'),
        width: 7,
        render: (data) => {
          const displayTitle = getEvidenceDisplayTitle(data, 60);

          return (
            <div>
              <label className="evidence-mainText">
                {data.year ? `${displayTitle} (${data.year})` : displayTitle}
              </label>
            </div>
          );
        },
      },
      {
        title: t('activity.evidence.form.author'),
        width: 3,
        render: (data) => {
          const authors = (data.author || '')
            .split(';')
            .map((name) => name.trim())
            .filter(Boolean);

          return (
            <div>
              {isEmpty(authors) ? (
                <label className="evidence-mainText">-</label>
              ) : (
                authors.map((name, i) => (
                  <label
                    key={i}
                    className="evidence-mainText evidence-author-line"
                  >
                    {name}
                  </label>
                ))
              )}
            </div>
          );
        },
      },
      {
        title: t('activity.evidence.form.material_type'),
        width: 3,
        render: (data) => {
          return (
            <div>
              <label className="evidence-mainText">
                {getEvidenceTypeLine(data) || '-'}
              </label>
            </div>
          );
        },
      },
      {
        title: '',
        width: 2,
        render: (data) => {
          return (
            <div>
              <Segment>
                <EvidenceEdit
                  evidence={data}
                  {...this.props}
                  isReadOnly={disabled}
                  isParent
                />
              </Segment>
            </div>
          );
        },
      },
      {
        title: '',
        width: 1,
        textAlign: 'right',
        render: (data) => {
          return (
            <div>
              <Segment disabled={disabled} className="evidence-remove-button">
                <EvidenceDelete evidence={data} {...this.props} />
              </Segment>
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { libraryOpen } = this.state;
    const { t, auth, activity, currentState } = this.props;
    const { currentActivity } = activity;
    const { title } = getActivityType(currentActivity);

    return (
      <>
        <div className="content-segment objective">
          <div>
            <ActivityParentGoalAndObjective noObjectives />
          </div>
          <Segment
            disabled={getPageDisable(currentActivity, auth.user, currentState)}
            className="content-segment evidence-sector"
            attached
          >
            <Grid>
              <Grid.Row>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <div>
                    <label className="parent-info">
                      {t('activity.evidence.consider_the_evidence', { title })}
                    </label>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>

          <Segment
            className="evidence-section-segment"
            disabled={getPageDisable(currentActivity, auth.user, currentState)}
          >
            <div className="evidence-section-header-row">
              <div className="evidence-actions-inline">
                <EvidenceCreate {...this.props} isParent />
                <div className="Secondary-Button" onClick={this.toggleLibrary}>
                  <Icon name="book" />
                  {t('activity.evidence.evidence_library')}
                </div>
              </div>
            </div>

            <SlideoutPanel
              open={libraryOpen}
              onClose={this.toggleLibrary}
              title={t('activity.evidence.evidence_library')}
              wide="library"
              className="dialog-width-xl"
            >
              {libraryOpen ? (
                <EvidenceLibrary {...this.props} isParent />
              ) : null}
            </SlideoutPanel>
          </Segment>
          <Segment className="evidence-table-segment">
            <CustomTable
              header
              columns={this.columns()}
              data={currentActivity.evidence}
              height={true}
              customClass="evidence-table-new"
              emptyMessage={t('activity.evidence.no_evidence_has_been_added')}
              keyExtractor={(item, index) => item.id}
            />
          </Segment>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    activity: state.activity,
    extra: state.extra,
    helpTips: state.extra.activityHelpTips,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getEvidenceTypes,
      deleteObjectiveEvidence,
    },
    dispatch
  );
};

ActivityParentEvidence = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActivityParentEvidence));

export { ActivityParentEvidence };
